import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

import lang from '../lang'

export default class extends React.Component {
  state = {
  }

  constructor(props) {
    super(props)
  }

  componentDidMount() {
  }

  componentWillReceiveProps(e) {
  }

  render() {
    let { language, lang, GroupSupper, displayBtn, GroupSupperApply } = this.props
    return (
      <div className="sign">
        {GroupSupper.canApply && !GroupSupper.applied && <div className="btn btn2" onClick={() => { GroupSupperApply() }}>
          {lang.sign}
        </div>}
        {GroupSupper.canApply && !GroupSupper.applied && <div style={{ height: '2rem' }}></div>}
        {!GroupSupper.canApply && displayBtn && < div className="btn">
          {lang.reportRes}
        </div>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport-op/Sign/index.js